import React from 'react';
import PropTypes from 'prop-types';
import { Modal, message } from 'antd';
import { ColaboradoresScroll } from './apontamentoProducao.styled';
import clipboard from '../../../services/util/clipboard';

const COOPERATORS_QUANTITY_MODAL_TITLE = 'Divergência na quantidade de Cooperados';

/**
 * Modal para exibir divergências na quantidade de cooperados
 */
export function ModalCooperatorsQuantity({ visible, cooperators, onOk, onCancel }) {
  const cooperatorsList = Array.isArray(cooperators) ? cooperators : [];
  const formattedText = cooperatorsList.join(',');

  const handleCopy = () => {
    clipboard(formattedText.replaceAll(',', '\n'));
    message.info('Informações copiadas');
  };

  return (
    <Modal
      title={COOPERATORS_QUANTITY_MODAL_TITLE}
      width={560}
      okText="Importar"
      okButtonProps={{
        style: {
          color: 'white',
        },
      }}
      cancelText="Cancelar"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <ColaboradoresScroll>
        <p>
          Foi encontrada uma divergência na quantidade de cooperados na lista importada. Os cooperados abaixo não
          constam em nossa base:
        </p>
        <ul>
          {cooperatorsList.map((cooperator, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index}>{cooperator}</li>
          ))}
        </ul>
        <p>Gostaria de seguir com a importacao?</p>
      </ColaboradoresScroll>
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <button
          type="button"
          onClick={handleCopy}
          style={{
            padding: '8px',
            cursor: 'pointer',
            marginBottom: '1em',
            background: 'none',
            border: 'none',
            color: '#1890ff',
            textDecoration: 'underline',
          }}
        >
          Clique aqui para copiar o texto
        </button>
      </div>
    </Modal>
  );
}

ModalCooperatorsQuantity.propTypes = {
  visible: PropTypes.bool.isRequired,
  cooperators: PropTypes.arrayOf(PropTypes.string),
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ModalCooperatorsQuantity.defaultProps = {
  cooperators: [],
};
